<form [formGroup]="sendForm">
  <div mat-dialog-content>
    <mat-form-field appearance="outline" style="width: 100%" color="primary">
      <mat-label>{{(data.isEmail ? 'common.email' : 'common.phone-number') | translate}}</mat-label>
      <input matInput name="email" [formControl]="emailFormControl" *ngIf="data.isEmail">
      <input matInput name="phone" [formControl]="phoneFormControl" *ngIf="!data.isEmail">
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <button mat-button type="button" color="warn" (click)="onNoClick()">{{'common.cancel' | translate}}</button>
    <button mat-button type="button" color="accent" (click)="onSendClick()" [disabled]="!sendForm.valid">{{'common.send' | translate}}</button>
  </div>
</form>